import React from 'react';
import { FaArrowRight, FaCalendarAlt, FaUser } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import '../css/blogCard.css'; // Custom CSS for styling

const BlogCard = ({ post }) => {
  const navigate = useNavigate();
  const { title, description, image, author, date, tags, slug } = post;

  const openArticle = () => {
    navigate(`/news/${slug}`, { state: { post } });
  };

  return (
    <div className="blog-card" onClick={openArticle}>
      {/* Blog image */}
      <div className="blog-image-container">
        <img src={image} alt={title} className="blog-image" />
        {tags?.[0] && <span className="blog-featured-tag">{tags[0]}</span>}
      </div>

      {/* Blog content */}
      <div className="blog-content">
        {/* Blog title */}
        <h2 className="blog-title">{title}</h2>

        {/* Blog description */}
        <p className="blog-description">{description}</p>

        {/* Author and Date */}
        <div className="blog-meta">
          <div className="blog-author">
            <FaUser className="meta-icon" /> {author}
          </div>
          <div className="blog-date">
            <FaCalendarAlt className="meta-icon" /> {date}
          </div>
        </div>

        {/* Tags (optional) */}
        {tags && (
          <div className="blog-tags">
            {tags.map((tag, index) => (
              <span key={index} className="blog-tag">
                {tag}
              </span>
            ))}
          </div>
        )}

        {/* Read more link */}
        <div className="read-more">
          <button
            type="button"
            className="read-more-link"
            onClick={(event) => {
              event.stopPropagation();
              openArticle();
            }}
          >
            Read More
            <FaArrowRight />
          </button>
        </div>
      </div>
    </div>
  );
};

export default BlogCard;
